// Пустой экран/вкладка: иллюстрация Figma, заголовок и подпись (по умолчанию — «данных пока нет»;
// если заголовок уже «No data yet», подпись по умолчанию не повторяет его — HQ-1321).
import { t } from '../i18n/i18n';
import { StateView } from '../ui/States';

export function Placeholder({ title, text }: { title: string; text?: string }) {
  const fallback = t('mc_no_data_yet');
  return <StateView art="empty" title={title} text={text ?? (fallback === title ? null : fallback)} />;
}
